<template>
  <div @click="adjustDates" class="container">
    <HotelDatePicker
      v-model="datepicker"
      ref="datepicker"
      :minNights="this.results.minNights"
      :disabledDates="this.results.disabledDates"
      :key="this.results.disabledDates"
    />
  </div>
</template>

<script>
import HotelDatePicker from "vue-hotel-datepicker";
import axios from "axios";
export default {
  props: {
    url: String,
  },
  data() {
    return {
      results: {
        minNights: 0,
        disabledDates: [],
      },
      checkIn: "",
      checkOut: "",
    };
  },
  components: {
    HotelDatePicker,
  },
  methods: {
    adjustDates: function() {
      this.checkIn = this.$refs.datepicker.checkIn;
      this.checkOut = this.$refs.datepicker.checkOut;
    },
  },
  mounted() {
    let url = this.url;
    axios.get(url).then((response) => {
      const { minNights, disabledDates } = response.data;
      this.results = {
        minNights,
        disabledDates,
      };
    });
  },
};
</script>

<style>
.datepicker__wrapper {
  margin-top: 40px;
}
</style>
